module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/mpp/templates/managers/Account.ejs -->\n<td>'+
((__t=( model.get('name') ))==null?'':_.escape(__t))+
'</td>\n<td>'+
((__t=( model.get('username') ))==null?'':_.escape(__t))+
'</td>\n<td>\n    <select name="managedCompanies"\n        class="form-control chosen-select"\n        multiple data-placeholder="No companies">\n        ';
 companies.forEach(function (c) { 
__p+='\n            <option value="'+
((__t=( c.id ))==null?'':_.escape(__t))+
'"\n                '+
((__t=( (model.get('managedCompanies') || []).indexOf(c.id) >= 0 ?
                    'selected' : '' ))==null?'':_.escape(__t))+
'>\n                '+
((__t=( c.get('companyName') ))==null?'':_.escape(__t))+
'\n            </option>\n        ';
 }) 
__p+='\n    </select>\n</td>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/mpp/templates/managers/Account.ejs
// module id = 1076
// module chunks = 1